var exports = {
  "kL": "xcc377c0b--3ff831--container",
  "AZ": "xcc377c0b--3ff831--room-count",
  "Lr": "xcc377c0b--3ff831--house-name",
  "p_": "xcc377c0b--3ff831--finish-date",
  "Wc": "xcc377c0b--3ff831--area",
  "q9": "xcc377c0b--3ff831--price",
  "j8": "xcc377c0b--3ff831--layout-image",
};

module.exports = exports;
